<template>
  <Breadcrumbs
      title="Edit Distributor Banks"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Distributor Banks', path: '/distributor-banks' },
      { label: 'Edit Distributor Banks', path: '/edit-banks' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <editBanks/>
    </div>
  </div>
</template>

<script>
import editBanks from './edit_banks_form.vue'
export default {
  name: 'indexList',
  components: {
    editBanks,
  },
}
</script>